import * as React from "react";
import { Order_orders_data_order_products } from '@api/graphql/types';

interface Props {
    orderProduct: Order_orders_data_order_products;
    printMode?: boolean;
}

const Price: React.SFC<Props> = (props) => {
    const { orderProduct, printMode } = props;

    if (orderProduct.price && orderProduct.special_price && orderProduct.special_price !== orderProduct.price) {
        return printMode ? (
            <>
                <span className="strikethrough">{orderProduct.price} Ft</span>
                <span className="specialPrice">{orderProduct.special_price} Ft</span>
            </>
        ) : (
            <strong>
                <span className="strikethrough">{orderProduct.price} Ft</span>
                <span className="specialPrice">{orderProduct.special_price} Ft</span>
            </strong>
        );
    } else if (orderProduct.price) {
        return printMode ? (<>{orderProduct.price} Ft</>) : (<strong>{orderProduct.price} Ft</strong>);
    }
    return null;
};

export default Price;



// WEBPACK FOOTER //
// ./src/modules/Order/components/Price.tsx